import React from 'react';
import AIEduButton from '../../components/Button/AIEduButton';
import AIEduDialog from '../../components/Dialog/AIEduDialog';
import { useIntl } from 'react-intl';

const DeleteTagDialog = ({
    hideDeleteTagsDialog,
    deleteSelectedTags,
    visible,
    deleteMessage,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const deleteTagDialogFooter = (
        <div className='flex justify-content-end'>
            <AIEduButton
                label='Cancel'
                className='btnSecondary'
                onClick={hideDeleteTagsDialog}
            />
            <AIEduButton
                label='Delete'
                className='btnDelete'
                onClick={deleteSelectedTags}
            />
        </div>
    );

    const deleteTagTitle = () => {
        return (
            <div
                className='flex justify-content-between pb-2'
                style={{ borderBottom: '1px solid var(--primary-background)' }}
            >
                <div>Delete Tag</div>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={hideDeleteTagsDialog}
                >
                    <i className='pi pi-times' />
                </div>
            </div>
        );
    };
    return (
        <AIEduDialog
            visible={visible}
            style={{ width: '40rem', fontFamily: 'SamsungOne-600, sans-serif' }}
            title={deleteTagTitle}
            footer={deleteTagDialogFooter}
            onHide={hideDeleteTagsDialog}
            content={
                <>
                    <i
                        className='pi pi-exclamation-triangle mr-3'
                        style={{ fontSize: '2rem' }}
                    />
                    <span>{deleteMessage}</span>
                </>
            }
        />
    );
};

export default DeleteTagDialog;
